import {combineReducers} from 'redux';
import {reducer as assist} from './assist';

const reducer = combineReducers({
    assist:assist,
});

export default reducer


// WEBPACK FOOTER //
// ./src/entry_app/knowledge_assist/reducer.js